"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var get = require("lodash/get");
var KEYWORD_DEV_TO_PROVIDE = 'devToProvide';
var CTEventManager = /** @class */ (function () {
    function CTEventManager(event) {
        this.event = event;
        this.devOverrides = {};
    }
    CTEventManager.init = function (config) {
        window.clevertap = __assign({}, window.clevertap, { config: config });
    };
    CTEventManager.prototype.fire = function (trigger, devOverrides) {
        this.devOverrides = devOverrides;
        var ctEvents = sessionStorage.getItem("ctEvents");
        ctEvents = ctEvents ? ctEvents.split(",") : [];
        ctEvents.push(trigger);
        sessionStorage.setItem("ctEvents", ctEvents.toString());
        try {
            var mergedEvent = this.merge();
            if (mergedEvent) {
                window.clevertap = window.clevertap || {}; // Safe check incase js loads before the initialization
                if (window.clevertap.event && !window.clevertap.config.disabled) {
                    window.clevertap.event.push(this.getValue('event_name'), mergedEvent);
                }
                else {
                    console.log("CleverTap Event: ", { name: this.getValue('event_name'), event: mergedEvent });
                }
            }
        }
        catch (err) {
            // tslint:disable-next-line:no-console
            console.error(err.message, trigger);
            return;
        }
    };
    CTEventManager.prototype.getValue = function (path) {
        var originalValue = get(this.event, path);
        if (originalValue === KEYWORD_DEV_TO_PROVIDE) {
            var overrideValue = get(this.devOverrides, path);
            if (overrideValue === null || overrideValue === undefined) {
                console.error("One of the devToProvide fields is missing - " + path);
            }
            return overrideValue;
        }
        return originalValue;
    };
    CTEventManager.prototype.merge = function () {
        return {
            page_section: this.getValue('page_section'),
            request_id: this.getValue('request_id'),
            category_key: this.getValue('category_key'),
            city_key: this.getValue('city_key'),
            code: this.getValue('code'),
            action_type: this.getValue('action_type'),
            amount: this.getValue('amount'),
            provider_id: this.getValue('provider_id'),
            revenue: this.getValue('revenue'),
            category_questions_id: this.getValue('category_questions_id'),
            question_template_type: this.getValue('question_template_type'),
            booking_time: this.getValue('booking_time'),
            status: this.getValue('status'),
            device_type: this.getValue('device_type'),
            appVersion: this.getValue('app_version'),
            country_key: this.getValue('country_key'),
            source: this.getValue('source')
        };
    };
    return CTEventManager;
}());
exports.CTEventManager = CTEventManager;
//# sourceMappingURL=Clevertap.js.map